const actionGetFormDataList = '/MobileApis/DataHandler.ashx?action=GetFormDataList'
const need = ["工会信息", "季度费用申请", "主席信箱", '办事处费用季度', '主席积分发放', '专项费用申请单', '统一福利发放表', '预算审批单', '员工慰问单', '活动积分兑换审批表', '积分备注', '线下福利发放表', '积分发放表', '统一积分发放表', '入会申请审批表', "会员信息修改审批单", "福利申请表", "补助申请表", "帮困金（临补）申请表", "会员七类特种疾病补助申请", "小组转移", "活动信息表", "会员补助填写", "工会费用银行付款申请", "工会活动申请表"]; // 我的申请显示的单子
const listapi = [{
    name: "公开的提问",
    mode: "textList", // 普通列表，即左图右字
    action: actionGetFormDataList,
    filter: [{key:"IsOpen",value:1,sqlOperator:"EN"}],
    shortTitle: "主席信箱视图",
    pageSize: 10, // 每页几行
    isRead: true,
    param: {
        name:"公开的提问",
        orderby:[{columnName:"CreateTime",sortType:"desc"}]
    },
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "我的提问",
    mode: "message", // 普通列表，即左图右字
    action: actionGetFormDataList,
    filter: [{key:"CreateUserId",value:"[info.Code]",sqlOperator:"EN"}],
    shortTitle: "主席信箱视图",
    pageSize: 10, // 每页几行
    isRead: true,
    param: {
        name:"我的提问",
        orderby:[{columnName:"CreateTime",sortType:"desc"}]
    },
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "未回复列表",
    mode: "message", // 普通列表，即左图右字
    action: "/MobileApis/DataHandler.ashx?action=GetWaitProcessNotice", // 请求数据的接口
    filter: [{key:"ProcessStatus",value:"待处理",sqlOperator:"EN"},{key:"CustomFormConfig.ShortTitle",value:"主席信箱",sqlOperator:"EN"}],
    shortTitle: "主席信箱视图",
    pageSize: 10, // 每页几行
    backReload: true,
    isRead: true,
    param: {
        orderby: [{columnName:"WriteDate",sortType:"desc"}]
    },
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "工会信息",
    mode: "default", // 普通列表，即左图右字
    action: actionGetFormDataList,
    shortTitle: "工会信息",
    filter: [{key:"IsRelease",value:'on',sqlOperator:"EN"}],
    filterNeedStationCode: true,
    firstSmall: true,
    param: {
        orderby:[{columnName:"ReleaseTime",sortType:"desc"}]
    },
    pageSize: 12, // 每页几行
    isRead: true,
    dateField: "ReleaseTime",
    search: true,
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "政策法规",
    mode: "default", // 普通列表，即左图右字
    action: actionGetFormDataList,
    shortTitle: "工会信息",
    filter: [{key:"Type",value:'党政工作',sqlOperator:"EN",sqlLogic:"and"},{key:"IsRelease",value:'on',sqlOperator:"EN"}],
    firstSmall: true,
    param: {
        orderby:[{columnName:"ReleaseTime",sortType:"desc"}]
    },
    pageSize: 12, // 每页几行
    isRead: true,
    dateField: "ReleaseTime",
    search: true,
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "组织架构",
    type: 'pdf',
    shortTitle: "组织机构图",
    action: "/MobileApis/DataHandler.ashx?action=GetAllFormDataList"
}, {
    name: "工会表格",
    mode: "pdf",
    shortTitle: "工会表格",
    action: actionGetFormDataList,
    pageSize: 12,
    param: {
        orderby:[]
    },
    filter: [{key:"Status",value:'on',sqlOperator:"EN"}],
}, {
    name: "会员手册",
    type: "操作手册",
    action: "/MobileApis/DataHandler.ashx?action=GetAllFormDataList",
    shortTitle: "会员手册"
}, {
    name: "工会活动",
    mode: "card", // 卡片列表,为头为大图片下面描述文字
    action: "/card",
    slot: "active",
    active: '0',
    pageSize: 12,
    backReload: true,
    backEvent: true,
    tabs: true,
    tab: [{
        name: "热门活动",
        active: '0',
        mode: "card",
        slot: "active",
        action: "/MobileApis/ActivityHandler.ashx?action=GetActivityList",
        pageSize: 12,
        backReload: true,
        param: {
            activityStatus: [{key:"CurrentStatus",value:"已结束",sqlOperator:"notEqual"}],
            orderby: ""
        }
    }, {
        name: "往期活动",
        active: '1',
        mode: "card",
        slot: "active",
        action: "/MobileApis/ActivityHandler.ashx?action=GetActivityList",
        pageSize: 12,
        backReload: true,
        param: {
            activityStatus: [{key:"CurrentStatus",value:"已结束",sqlOperator:"EN"}],
            orderby: ""
        },
    }],
}, {
    name: "工会集锦",
    mode: "card", // 卡片列表,为头为大图片下面描述文字
    action: "/MobileApis/UnionActiveHandler.ashx?action=Query",
    shortTitle: "工会集锦视图",
    pageSize: 12,
    share: true,
    leftGoRight: true,
    filter:[{key:"BannerTitle",value:'工会集锦',sqlOperator:"EN"}],
    param: {
        orderby: ""
    },
}, {
    name: "活动分享",
    mode: "card", // 卡片列表,为头为大图片下面描述文字
    action: actionGetFormDataList,
    shortTitle: "活动分享发布",
    pageSize: 12,
    share: true,
    filter: [{key:"BannerTitle",value:'活动分享',sqlOperator:"EN",sqlLogic:"and"},{key:"IsRelease",value:'on',sqlOperator:"EN"}],
    dateField: "StartTime",
    endField: "EndTime",
    search: true,
    param: {
        orderby:[{columnName:"CreateTime",sortType:"desc"}]
    },
}, {
    name: "家庭日",
    mode: "card", // 卡片列表,为头为大图片下面描述文字
    action: actionGetFormDataList,
    shortTitle: "活动分享发布",
    pageSize: 12,
    share: true,
    filter: [{key:"BannerTitle",value:'家庭日',sqlOperator:"EN",sqlLogic:"and"},{key:"IsRelease",value:'on',sqlOperator:"EN"}],
    filterYear: true,
    param: {
        orderby:[{columnName:"CreateTime",sortType:"desc"}]
    },
}, {
    name: "篮球赛",
    mode: "card", // 卡片列表,为头为大图片下面描述文字
    action: actionGetFormDataList,
    shortTitle: "活动分享发布",
    pageSize: 12,
    filter: [{key:"BannerTitle",value:'篮球赛',sqlOperator:"EN",sqlLogic:"and"},{key:"IsRelease",value:'on',sqlOperator:"EN"}],
    filterYear: true,
    param: {
        ActivityParton: '兴趣俱乐部活动',
        orderby: [{columnName:"CreateTime",sortType:"desc"}]
    },
}, {
    name: "生日慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, 
// {
//     name: "电影观摩",
//     action: actionGetFormDataList,
//     shortTitle: "福利类型列表",
//     filterTypeName: true,
//     pageSize: 10,
//     param: {
//         orderby: [{columnName:"SortIndex",sortType:""}]
//     },
// }, 
{
    name: "高温慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "节日慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "儿童节慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "职代会纪念品",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "妇女节慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "退休福利",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "生育慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    submitTitle: "福利申请表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: 'birth',
}, {
    name: "结婚慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    submitTitle: "福利申请表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: 'marry',
}, {
    name: "病假慰问",
    action: actionGetFormDataList,
    shortTitle: "福利类型列表",
    filterTypeName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    }
}, {
    name: "上级工会临时帮困",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    submitTitle: "会员补助填写",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: "subsidy"
}, {
    name: "会员七类特种病补助",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    submitTitle: "会员七类特种疾病补助申请",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: "disease"
}, {
    name: "会员直系亲属重大疾病补助",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    submitTitle: "补助申请表",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: "majordisease"
}, {
    name: "工会会员伤残帮困补助",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "工会会员因公去世帮困补助",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "会员重病关爱保障",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    submitTitle: "会员补助填写",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: "subsidy"
}, {
    name: "工会会员非因公去世帮困补助",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
}, {
    name: "“爱助”计划帮扶金",
    action: actionGetFormDataList,
    shortTitle: "补助信息列表",
    submitTitle: "会员补助填写",
    filterName: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"SortIndex",sortType:""}]
    },
    slot: "subsidy"
}, {
    name: "代表名单",
    action: '/MobileApis/UnionHotHandler.ashx?action=QueryWorkdersCongress',
    shortTitle: "",
    // search: true,
    firstSmall: true,
    searchSelect:true,
    pageSize: 10, 
    param: {
        orderby: [{columnName:"CreateTime",sortType:"desc"}]
    },
}, {
    name: "职代会代表专线",
    mode: "ghrd",
    action: actionGetFormDataList,
    shortTitle: "职代会热点视图",
    filter: [{key:"ComeFrom",value:"[info.Code]",sqlOperator:"EN"}],
    firstSmall: true,
    pageSize: 10,
    param: {
        orderby: [{columnName:"IsTop",sortType:"Desc"},{columnName:"CreateTime",sortType:"Desc"}],
    },
    isAgree: true,
    agreeList: {
        action: "/MobileApis/CommentHandler.ashx?action=GetDZCount",
    },
    isRead: true,
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "工会发布列表",
    action: actionGetFormDataList,
    shortTitle: "工会热点信息",
    search: true,
    firstSmall: true,
    pageSize: 12,
    filter: "",
    param: {
        orderby: [{columnName:"IsTop",sortType:"Desc"},{columnName:"CreateTime",sortType:"Desc"}],
    },
}, {
    name: "代表职责",
    action: '/MobileApis/UnionHotHandler.ashx?action=GetVideo',
    filter: "",
}, {
    name: "我的发布",
    action: actionGetFormDataList,
    shortTitle: "职代会热点视图",
    pageSize: 10,
    filter: [{key:"MemberCode",value:"[info.Code]",sqlOperator:"EN"}],
    param: {
        orderby: [],
    },
}, {
    name: "我的评论",
    action: '/MobileApis/CommentHandler.ashx?action=GetMyComment',
    shortTitle: "职代会热点视图",
    pageSize: 10,
    filter: [],
    param: {
        orderby: "",
    },
}, {
    name: "我的消息",
    action: '/MobileApis/PersonalMessageHandler.ashx?action=GetMsgList',
    pageSize: 10,
    filter: [],
    param: {
        orderby: [],
    },
}, {
    name: "我的信息",
    action: '/MobileApis/MemberChangeHandler.ashx?action=GetMemberChangeStatus',
    shortTitle: "人员信息表",
    param: {
        type: "123",
    },
}, {
    name: "入会申请",
    action: '/MobileApis/MemberChangeHandler.ashx?action=GetMemberChangeStatus',
    shortTitle: "人员信息表",
    param: {
        type: "123",
    },
},  {
    name: "我的积分",
    mode: "score",
    action: "/MobileApis/WalletBillHandler.ashx?action=GetWalletBill",
    pageSize: 10,
    tabs: true,
    active: '0',
    tab: [{
        name: "积分明细",
        mode: "score",
        action: "/MobileApis/WalletBillHandler.ashx?action=GetWalletBill",
        pageSize: 10,
        active: '0',
        param: {}
    }]
}, {
    name: "我的代金券",
    mode: "cash",
    action: "/MobileApis/WalletBillHandler.ashx?action=GetMoneyListForUser",
    pageSize: 10,
    tabs: true,
    active: '0',
    tab: [{
        name: "代金券明细",
        mode: "cash",
        action: "/MobileApis/WalletBillHandler.ashx?action=GetMoneyListForUser",
        pageSize: 10,
        active: '0',
    }]
}, {
    name: "我的福利",
    mode: 'fuli',
    action: '/MobileApis/WelfareHandler.ashx?action=Query',
    shortTitle: "",
    pageSize: 10,
    fiter: '',
    param: {
        orderby: "",
    },
}, {
    name: "我的活动",
    action: '/MobileApis/ActivityHandler.ashx?action=GetActivityList',
    pageSize: 12,
    filter: "",
    param: {
        orderby: "",
        my: 1
    },
}, {
    name: "我的申请",
    mode: "message", // 普通列表，即左图右字
    action: "/MobileApis/DataHandler.ashx?action=GetWaitProcessNotice", // 请求数据的接口
    filter: "",
    pageSize: 10, // 每页几行
    backReload: true,
    isRead: true,
    filterScreen: need.filter((item) => {
        return item != '小组转移' && item != '活动信息表'
    }),
    filterMe: true,
    param: {
        orderby: [{columnName:"WriteDate",sortType:"desc"}],
        type: "原稿",
    },
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "我的电子卡",
    slot: "dzCrad",
    action: '/MobileApis/SendMessageHandler.ashx?action=GetECardMessageList',
    pageSize: 12,
    filter: "",
    param: {
        orderby: "",
    },
}, {
    name: "我的兑换",
    mode: "myDh",
    action: "/MobileApis/WalletBillHandler.ashx?action=GetWalletBill",
    pageSize: 10,
    tabs: true,
    active: '0',
    tabs: true,
    tab: [{
            name: "京东兑换",
            active: '0',
            mode: "myDh",
            action: "/MobileApis/WalletBillHandler.ashx?action=GetWalletBill",
            pageSize: 10,
            param: {
                billType: 6,
                orderby: "",
            }
        },
        // {
        //     name: "东方福利兑换平台",
        //     active: '1',
        //     mode: "card",
        //     slot: "active",
        //     action: "/MobileApis/WalletBillHandler.ashx?action=GetWalletBill",
        //     pageSize: 10,
        //     param: {
        //         billType: 7
        //     },
        // }
    ],
}, {
    name: "操作手册",
    shortTitle: "会员手册",
    action: "/MobileApis/DataHandler.ashx?action=GetAllFormDataList",
    filter: ""
}, {
    name: "待处理",
    action: "/MobileApis/DataHandler.ashx?action=GetWaitProcessNotice",
    shortTitle: "会员补助填写",
    pageSize: 10, // 每页几行
    backReload: true,
    isRead: true,
    filter: "",
    filterScreen: need,
    param: {
        orderby: [{columnName:"Notice.Processstatus",sortType:""},{columnName:"SendTime",sortType:"desc"}],
        ProcessStatus: "待处理,收件",
    },
    readList: {
        action: "/MobileApis/DataHandler.ashx?action=GetFormDataIsRead",
        configID: []
    },
}, {
    name: "已处理",
    action: "/MobileApis/DataHandler.ashx?action=GetWaitProcessNotice",
    pageSize: 10, // 每页几行
    shortTitle: "会员补助填写",
    filterScreen: need,
    param: {
        ProcessStatus: '已处理',
        orderby: [{columnName:"ProcessTime",sortType:"desc"}]
    },
}];

export const apilist = listapi